var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _vm.version === 2
        ? _c(
            "div",
            {
              staticClass: "wrapper",
              class: { winter: _vm.currentSeason === 2 },
            },
            [
              _c("div", [
                _c("canvas", { ref: "canvas", staticClass: "canvas" }),
                _c(
                  "div",
                  { staticClass: "temperature" },
                  [
                    _vm.config.hireTemperature > 0
                      ? [
                          _vm.config.hireModel === 1
                            ? _c(
                                "svg",
                                {
                                  staticClass: "svg",
                                  attrs: {
                                    t: "1679966763975",
                                    viewBox: "0 0 1024 1024",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "p-id": "2279",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M897.22368 446.446592C895.0272 446.446592 892.786688 446.160896 890.564608 445.553664L746.604544 406.71744C741.357568 405.302272 736.939008 402.33984 733.677568 398.45888L546.226176 507.445248 740.31616 620.291072C742.247424 619.15648 744.34048 618.235904 746.604544 617.6256L890.564608 578.78016C904.249344 575.062016 918.336512 583.26528 921.99424 597.055488 925.663232 610.844672 917.541888 625.012736 903.84896 628.706304L802.039808 656.178176 893.188096 709.172224C901.376 713.934848 904.173568 724.467712 899.452928 732.71296 896.279552 738.240512 890.53184 741.327872 884.617216 741.327872 881.716224 741.327872 878.777344 740.589568 876.077056 739.022848L777.892864 681.93792 808.14592 795.629568C811.813888 809.419776 803.693568 823.58784 789.999616 827.280384 787.777536 827.886592 785.537024 828.173312 783.340544 828.173312 772.011008 828.173312 761.63584 820.558848 758.569984 809.007104L719.995904 664.04352C718.590976 658.761728 718.927872 653.428736 720.631808 648.645632L529.61792 537.587712 529.61792 763.502592C532.95104 764.758016 536.08448 766.712832 538.766336 769.41312L644.151296 875.532288C654.17728 885.620736 654.17728 901.984256 644.151296 912.079872 639.138816 917.128192 632.571904 919.653376 626.004992 919.653376 619.437056 919.653376 612.871168 917.128192 607.859712 912.079872L529.61792 833.294336 529.61792 943.024128C529.61792 952.539136 521.834496 960.256 512.236544 960.256 502.637568 960.256 494.854144 952.539136 494.854144 943.024128L494.854144 833.1264 416.451584 912.079872C411.440128 917.128192 404.873216 919.653376 398.306304 919.653376 391.739392 919.653376 385.17248 917.128192 380.158976 912.079872 370.134016 901.993472 370.134016 885.620736 380.158976 875.532288L485.536768 769.41312C488.26368 766.666752 491.457536 764.695552 494.854144 763.4432L494.854144 537.31328 303.369216 648.644608C305.074176 653.428736 305.412096 658.760704 304.007168 664.04352L265.44128 809.007104C262.376448 820.550656 251.998208 828.173312 240.669696 828.173312 238.472192 828.173312 236.232704 827.886592 234.0096 827.280384 220.316672 823.58784 212.195328 809.419776 215.86432 795.629568L246.111232 681.935872 148.225024 738.847744C145.533952 740.411392 142.584832 741.152768 139.684864 741.152768 133.77024 741.152768 128.023552 738.064384 124.849152 732.536832 120.127488 724.292608 122.92608 713.757696 131.115008 708.996096L221.961216 656.177152 120.16128 628.706304C106.467328 625.012736 98.347008 610.844672 102.014976 597.055488 105.68192 583.26528 119.77728 575.062016 133.445632 578.78016L277.397504 617.6256C279.660544 618.235904 281.754624 619.15648 283.684864 620.291072L477.773824 507.445248 290.323456 398.45888C287.06304 402.33984 282.64448 405.302272 277.397504 406.71744L133.445632 445.553664C131.222528 446.160896 128.985088 446.446592 126.78656 446.446592 115.457024 446.446592 105.081856 438.832128 102.014976 427.281408 98.347008 413.4912 106.467328 399.322112 120.16128 395.628544L233.064448 365.167616 135.175168 308.25472C126.988288 303.49312 124.188672 292.958208 128.909312 284.713984 133.63712 276.476928 144.072704 273.642496 152.285184 278.404096L243.13856 331.227136 215.86432 228.70528C212.195328 214.91712 220.316672 200.748032 234.0096 197.054464 247.712768 193.327104 261.782528 201.53856 265.44128 215.328768L304.007168 360.292352C304.613376 362.5728 304.868352 364.859392 304.858112 367.111168L494.854144 477.577216 494.854144 260.723712C491.457536 259.47136 488.26368 257.50016 485.536768 254.754816L380.158976 148.627456C370.134016 138.529792 370.134016 122.166272 380.158976 112.078848 390.18496 101.983232 406.426624 101.983232 416.451584 112.078848L494.854144 191.038464 494.854144 81.486848C494.854144 71.972864 502.637568 64.256 512.236544 64.256 521.834496 64.256 529.61792 71.972864 529.61792 81.486848L529.61792 190.870528 607.859712 112.078848C617.883648 101.983232 634.125312 101.983232 644.151296 112.078848 654.17728 122.166272 654.17728 138.539008 644.151296 148.627456L538.766336 254.754816C536.08448 257.45408 532.95104 259.407872 529.61792 260.66432L529.61792 477.302784 719.143936 367.110144C719.13472 364.858368 719.389696 362.5728 719.995904 360.292352L758.569984 215.328768C762.227712 201.53856 776.31488 193.327104 789.999616 197.054464 803.693568 200.748032 811.813888 214.91712 808.14592 228.70528L780.86656 331.224064 872.016896 278.227968C880.188416 273.456128 890.665984 276.301824 895.392768 284.537856 900.114432 292.783104 897.314816 303.315968 889.127936 308.078592L790.936576 365.167616 903.84896 395.628544C917.541888 399.322112 925.663232 413.4912 921.99424 427.281408 918.928384 438.823936 908.553216 446.446592 897.22368 446.446592Z",
                                      "p-id": "2280",
                                      fill: "#fff",
                                    },
                                  }),
                                ]
                              )
                            : _vm.config.hireModel === 2
                            ? _c(
                                "svg",
                                {
                                  staticClass: "svg",
                                  attrs: {
                                    t: "1679966976175",
                                    viewBox: "0 0 1024 1024",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "p-id": "2550",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M264.940168 289.852458a29.357102 29.357102 0 0 1-19.571402-8.807131l-92.377015-92.377016a27.987104 27.987104 0 0 1 1.761426-39.142803 29.357102 29.357102 0 0 1 37.381377 0l92.377016 92.377016a27.987104 27.987104 0 0 1 0 39.142803 22.89854 22.89854 0 0 1-19.571402 8.904988m590.077758 591.839184a36.598521 36.598521 0 0 1-19.571401-7.143562l-94.236299-92.377015a27.693533 27.693533 0 0 1 37.381377-40.90423l1.761426 1.859284 94.138442 92.377015a27.595676 27.595676 0 0 1 0 39.142803 36.500664 36.500664 0 0 1-19.571402 7.143562m-684.314057 0a27.693533 27.693533 0 0 1-19.571401-46.188508L243.509483 743.713261a27.595676 27.595676 0 1 1 39.142803 39.142803l-94.236298 92.377015a26.519249 26.519249 0 0 1-17.712119 7.143562m590.077758-591.839184a26.617106 26.617106 0 0 1-26.617106-28.47639 28.378532 28.378532 0 0 1 8.904988-19.571401l94.138442-92.377016a27.987104 27.987104 0 0 1 39.142803 1.761426 29.357102 29.357102 0 0 1 0 37.381377l-92.377016 93.5513a28.182818 28.182818 0 0 1-23.192111 7.143562M160.037455 540.562112H28.41978A26.714963 26.714963 0 0 1 1.802674 512.085723a26.127821 26.127821 0 0 1 26.617106-26.617106h131.617675a26.617106 26.617106 0 0 1 26.617107 28.378532 27.399962 27.399962 0 0 1-26.617107 26.714963m835.307421 0H863.922914a26.714963 26.714963 0 0 1-26.714963-28.476389 26.127821 26.127821 0 0 1 26.714963-26.617106h131.421962a26.617106 26.617106 0 0 1 26.714963 28.378532 25.247108 25.247108 0 0 1-26.714963 26.714963m-483.41362 483.413619a27.595676 27.595676 0 0 1-28.378532-26.617106V865.838807a27.693533 27.693533 0 1 1 55.093495-5.382136v135.140528a25.736393 25.736393 0 0 1-26.714963 28.378532m0-835.30742a27.693533 27.693533 0 0 1-28.378532-26.714963V30.433529a27.693533 27.693533 0 0 1 55.093495-5.382135v135.140528a25.83425 25.83425 0 0 1-26.714963 28.476389m0 110.186991a214.20899 214.20899 0 1 0 215.285418 213.230421 214.20899 214.20899 0 0 0-215.285418-213.230421m0 483.41362a268.128202 268.128202 0 0 1-268.323916-268.030345 268.421773 268.421773 0 0 1 536.745689 0 266.953918 266.953918 0 0 1-268.421773 268.030345",
                                      "p-id": "2551",
                                      fill: "#fff",
                                    },
                                  }),
                                ]
                              )
                            : _c(
                                "svg",
                                {
                                  staticClass: "svg",
                                  attrs: {
                                    t: "1679967000470",
                                    viewBox: "0 0 1024 1024",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "p-id": "2777",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M41.890909 549.236364c-4.654545 0-9.309091 0-16.290909-2.327273-9.309091-4.654545-25.6-16.290909-25.6-30.254546 0-11.636364 11.636364-27.927273 20.945455-34.90909 6.981818-4.654545 16.290909-4.654545 23.272727-4.654546h772.654545c65.163636 0 111.709091-30.254545 128-83.781818 18.618182-58.181818-11.636364-123.345455-69.818182-146.618182-13.963636-4.654545-27.927273-9.309091-44.218181-9.309091-46.545455 0-88.436364 25.6-107.054546 67.490909-2.327273 4.654545-4.654545 9.309091-4.654545 13.963637-2.327273 4.654545-2.327273 6.981818-4.654546 11.636363-6.981818 16.290909-18.618182 25.6-30.254545 25.6-4.654545 0-11.636364-2.327273-16.290909-4.654545-11.636364-6.981818-23.272727-30.254545-20.945455-44.218182 13.963636-67.490909 81.454545-130.327273 153.6-139.636364 9.309091 0 18.618182-2.327273 25.6-2.327272 95.418182 0 172.218182 62.836364 190.836364 153.6 18.618182 102.4-41.890909 197.818182-144.290909 221.090909-20.945455 4.654545-41.890909 4.654545-62.836364 4.654545H48.872727c0 4.654545-2.327273 4.654545-6.981818 4.654546zM672.581818 984.436364c-58.181818 0-114.036364-30.254545-141.963636-81.454546-6.981818-11.636364-23.272727-39.563636 6.981818-58.181818 6.981818-4.654545 13.963636-6.981818 20.945455-6.981818 16.290909 0 27.927273 13.963636 34.90909 27.927273 18.618182 30.254545 44.218182 46.545455 76.8 46.545454h16.29091c37.236364-4.654545 62.836364-27.927273 74.472727-67.490909 6.981818-25.6 2.327273-51.2-13.963637-72.145455-13.963636-20.945455-37.236364-34.909091-62.836363-37.236363-27.927273-2.327273-58.181818-2.327273-81.454546-2.327273h-558.545454c-4.654545 0-11.636364 0-18.618182-4.654545-9.309091-4.654545-23.272727-18.618182-23.272727-30.254546s11.636364-25.6 20.945454-32.581818c6.981818-4.654545 13.963636-4.654545 20.945455-4.654545h609.745454c97.745455 0 162.909091 51.2 179.2 137.30909 13.963636 76.8-30.254545 153.6-102.4 179.2-18.618182 4.654545-37.236364 6.981818-58.181818 6.981819z",
                                      "p-id": "2778",
                                      fill: "#fff",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M244.363636 365.381818H46.545455c-13.963636 0-27.927273 0-37.236364-9.309091-6.981818-6.981818-9.309091-16.290909-9.309091-25.6 0-37.236364 32.581818-37.236364 53.527273-37.236363h370.036363c46.545455 0 83.781818-32.581818 90.763637-79.127273 4.654545-46.545455-20.945455-86.109091-67.490909-100.072727-6.981818-2.327273-13.963636-2.327273-20.945455-2.327273-27.927273 0-55.854545 13.963636-72.145454 37.236364-2.327273 2.327273-4.654545 6.981818-6.981819 9.30909-2.327273 2.327273-4.654545 6.981818-6.981818 9.309091-9.309091 11.636364-20.945455 18.618182-30.254545 18.618182-6.981818 0-13.963636-2.327273-18.618182-9.309091-11.636364-9.309091-16.290909-34.909091-11.636364-46.545454 20.945455-53.527273 81.454545-93.090909 144.290909-93.090909h11.636364c88.436364 6.981818 153.6 81.454545 151.272727 167.563636-2.327273 88.436364-72.145455 155.927273-158.254545 158.254545h-74.472727c-18.618182 2.327273-93.090909 2.327273-109.381819 2.327273z",
                                      "p-id": "2779",
                                      fill: "#fff",
                                    },
                                  }),
                                ]
                              ),
                          _c("p", { staticClass: "text" }, [
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.config.hireTemperature)),
                            ]),
                            _c("span", { staticClass: "font-xxl" }, [
                              _vm._v("℃"),
                            ]),
                          ]),
                        ]
                      : [
                          _c(
                            "svg",
                            {
                              staticClass: "svg",
                              attrs: {
                                t: "1680168584543",
                                viewBox: "0 0 1024 1024",
                                version: "1.1",
                                xmlns: "http://www.w3.org/2000/svg",
                                "p-id": "6042",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M511.878001 1023.989c-62.999385 0-124.098788-11.699886-181.698225-34.999658-55.699456-22.49978-105.798967-54.499468-148.798547-95.599067-43.099579-40.9996-76.899249-88.899132-100.599018-142.198611-24.59976-55.29946-36.999639-114.098886-36.999639-174.698294 0-76.79925 20.699798-152.498511 59.899415-219.197859 37.799631-64.099374 92.299099-119.098837 157.498462-158.598451 14.699856-8.999912 33.899669-4.299958 42.899581 10.499897 8.999912 14.699856 4.299958 33.899669-10.499897 42.899581-56.399449 34.199666-103.498989 81.599203-136.19867 137.098661-33.599672 56.999443-51.1995 121.798811-51.1995 187.39817 0 102.498999 41.99959 199.098056 118.298845 271.697347 76.699251 73.099286 178.798254 113.298894 287.497192 113.298893s210.797941-40.299606 287.497193-113.298893c76.299255-72.799289 118.298845-169.198348 118.298844-271.797346 0-130.298728-68.699329-250.797551-183.798205-322.296852-14.599857-9.099911-19.099813-28.299724-9.999902-42.99958 9.099911-14.599857 28.299724-19.099813 42.99958-9.999903 64.099374 39.799611 117.498853 94.599076 154.59849 158.398453 38.399625 66.099354 58.699427 140.998623 58.699427 217.09788 0 60.599408-12.499878 119.398834-36.999639 174.698294-23.699769 53.299479-57.499438 101.199012-100.599017 142.198612-42.99958 40.899601-93.099091 73.099286-148.798547 95.599066-57.799436 23.099774-118.998838 34.79966-181.998223 34.79966zM511.878001 506.394055c-17.199832 0-31.199695-13.899864-31.199695-31.199696v-443.995664c0-17.199832 13.899864-31.199695 31.199695-31.199695 17.199832 0 31.199695 13.899864 31.199696 31.199695v443.895665c0.099999 17.199832-13.999863 31.299694-31.199696 31.299695z",
                                  "p-id": "6043",
                                  fill: "#fff",
                                },
                              }),
                            ]
                          ),
                          _c("p", [_vm._v("待机")]),
                        ],
                  ],
                  2
                ),
                _c("div", { staticClass: "flex-between" }, [
                  _c("p", [_vm._v("16℃")]),
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      class: { "active-speed": _vm.config.hireWindSpeed === 3 },
                      attrs: {
                        t: "1680248021464",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "3718",
                        width: "24",
                        height: "24",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M131.3 363.3c-19.2 47.3-28.9 97.3-28.9 148.7 0 51.3 9.7 101.3 28.9 148.7 7 17.2 15.1 33.8 24.3 49.7l15.8-49.1 42.8 13.8-39.8 123.8-42.8-13.9-80.9-26 13.8-42.8 52.3 16.8c-98-168.4-74.8-387.9 69.4-532.1C342.4 44.7 586.9 30.5 759.1 158.3l-32.2 32.2c-25.1-18-52.1-32.9-80.9-44.6-47.3-19.2-97.3-28.9-148.7-28.9-51.3 0-101.3 9.7-148.7 28.9-49 19.9-92.9 49.1-130.6 86.8s-66.9 81.7-86.7 130.6z m828.3-60.2l13.8-42.8-80.9-26-42.8-13.8-39.8 123.8 42.8 13.8 15-46.7c9.8 16.6 18.4 34 25.8 52.1 19.2 47.3 28.9 97.3 28.9 148.7 0 51.3-9.7 101.3-28.9 148.7-19.9 49-49.1 92.9-86.8 130.6C768.9 829 725 858.2 676 878.1c-47.3 19.2-97.3 28.9-148.7 28.9-51.3 0-101.3-9.7-148.7-28.9-28.8-11.7-55.9-26.6-80.9-44.6l-32.2 32.2c126.3 93.7 382.6 147.7 572.9-42.6 145.8-145.8 167.9-368.6 66.1-537.7l55.1 17.7zM474 241.2L295 730.4h64.8l50.5-148.2h195.3l54 148.2h70.3L539.6 241.2H474z m-45.9 288.3L479.8 386c11-30.9 19.4-62.1 25.4-93.4 6.9 26 17.9 59.9 32.8 101.5l48.2 135.5H428.1z",
                          fill: "#999",
                          "p-id": "3719",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "svg",
                    {
                      class: { "active-speed": _vm.config.hireWindSpeed === 0 },
                      attrs: {
                        t: "1679650057641",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "9570",
                        width: "24",
                        height: "24",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M691.4 129.4c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-12.1 9.1-23.2 19.2-33 29.9l-28.4 31.1-1.6-6.2c-10.3-40.3-14.4-77.3-12.1-110 2.6-36.2 13.2-67.2 31.5-92.2 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9.2 38.6-13.9 59.4-13.9M566.7 432.8l37.1 16c31.6 13.6 51.9 44.6 51.9 79 0 1.8-0.1 3.8-0.2 5.8l-2.4 36.6-28.3 23.6c-15.6 13.1-34.7 20-55.1 20-16.2 0-32-4.5-45.7-13.1l-32.6-20.5-6.4-37.7c-0.8-4.8-1.2-9.7-1.2-14.6 0-16.2 4.5-32 13.1-45.6 8.3-13.3 20.2-24.1 34.1-31.2l35.7-18.3m-358.8 73.4c29.4 0 54.5 15 89.2 35.8 23.1 13.8 49.3 29.5 81.3 43.1 15.7 6.7 31.7 11.6 47.6 14.7l36.6 7.2-0.7 0.7c-27.6 27.8-55.7 49.5-83.3 64.6-30.6 16.7-60.8 25.2-89.8 25.2-5.4 0-10.9-0.3-16.4-0.9-20.2-2.2-38.7-7.4-55-15.6-14.5-7.2-27.4-16.8-38.3-28.4-19.5-20.8-32.3-48.5-35.3-76-1.9-17.3 0.3-33.4 6-45.3 6.6-13.8 15.7-16.9 18.6-17.9 14.6-4.8 27.5-7.2 39.5-7.2m484.7 79.1h0.2c42 10.9 77.8 26 106.3 44.6 31.8 20.8 54.5 46.2 67.4 75.6 28.8 65.3 7.7 114-7.5 137.3-10.5 16.2-24.2 29.7-39.6 39.1-13.2 8.1-26.9 12.6-38.6 12.6-8.6 0-15.4-2.4-21-7.3-24.6-21.8-31.7-39.8-35.2-53.1-5.3-20.2-4.9-44.5-4.4-72.6 0.4-26.9 0.9-57.5-3.3-92-2.4-19.2-6.8-37.7-13.3-54.9l-11-29.3m-1.2-505.9c-53.8 0-112.1 23.4-155.6 82.8-51.8 70.8-48.4 163-27.5 244.3-44.2 22.4-74.6 68.4-74.6 121.4 0 7.8 0.7 15.5 1.9 23-12.1-2.4-24.7-6.2-37.7-11.7-78.7-33.4-121.9-82.9-190.1-82.9-16.7 0-34.8 3-55.3 9.8C48 501 78.5 725.9 267 746.4c7.3 0.8 14.6 1.2 21.8 1.2 80.9 0 153-48.5 208.6-104.5 20.9 13.2 45.7 20.8 72.3 20.8 33.2 0 63.6-11.9 87.2-31.6 4.9 13 8.5 27.4 10.5 43.4 12.9 105.6-23.1 176 59.4 249.1 15.4 13.7 34.3 19.9 54.2 19.9 86.5 0 193.5-118.2 131.3-259.2-36.7-83.4-123.1-126.7-206.9-148.5 0.2-3 0.3-6.1 0.3-9.1 0-56-33.8-104-82.1-124.9 7.5-8.2 16.2-16.1 26.2-23.7 85-64 164-68 186-176C849.3 137.2 776 79.4 691.4 79.4z",
                          fill: "#999",
                          "p-id": "9571",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "svg",
                    {
                      class: { "active-speed": _vm.config.hireWindSpeed === 1 },
                      attrs: {
                        t: "1679650045156",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "9424",
                        width: "24",
                        height: "24",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M632.7 112.6c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-12.3 9.3-23.6 19.5-33.5 30.4l-27.9 30.7-1.3-5.2c-10.5-40.5-14.7-77.7-12.4-110.7 2.5-36.4 13.1-67.6 31.5-92.8 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9 38.6-13.7 59.4-13.7M173.2 316.8c1.9 0 3.8 0.2 5.8 0.6 32.2 6.6 47.4 18.6 57 28.4 14.6 14.9 26.5 36.1 40.1 60.7 13.1 23.5 27.9 50.2 48.9 78 6.5 8.6 13.5 16.7 20.8 24.2l37.2 38c-34 9-65.9 13.5-94.9 13.5-21.6 0-41.6-2.6-59.6-7.6-18.9-5.3-36.1-13.6-51-24.5-63.7-46.6-70.6-111.5-55.8-156.7 10.2-31.7 31.9-54.6 51.5-54.6m335.1 100.4l36.9 15.5c20.2 8.4 36.2 24.1 45.2 44l16.6 36.7-17.6 36.2c-7.2 14.9-18.5 27.3-32.7 35.9l-32 19.5 0.8 3-42.1-14.8c-16.2-5.7-30.2-16-40.5-29.9l-20.5-27.5-7.7 2.1 14.7-50.1c6.6-22.5 22.4-41.6 43.3-52.3l35.6-18.3m227.6 75.6c44.3 0 81.5 10.8 110.6 32.1 63.7 46.6 70.6 111.5 55.8 156.7-10.3 31.6-32 54.5-51.6 54.5-1.9 0-3.8-0.2-5.8-0.6-32.2-6.6-47.4-18.6-57-28.4-14.6-14.9-26.5-36.1-40.1-60.7-13.1-23.5-27.9-50.2-48.9-78-9.5-12.6-20-24.1-31.2-34.2l-30.2-27.1 10.4-2.6c31.5-7.7 61.1-11.7 88-11.7M534.6 641.5c11.1 41.2 15.7 79.1 13.6 112.6-2.3 37.3-12.9 69.3-31.7 94.9-15.8 21.6-34.6 37.9-55.9 48.5-18.6 9.2-38.6 13.9-59.4 13.9-18.2 0-36.3-3.7-52.3-10.6-14.2-6.2-26.3-14.9-34.2-24.4-11.8-14.5-9.7-25.2-8.9-28.8 6.6-32.2 18.6-47.4 28.4-57 14.9-14.6 36.1-26.5 60.7-40.1 23.5-13.1 50.2-27.9 78-48.9 10.9-8.2 21.1-17.2 30.1-26.8l31.6-33.3m98.1-578.9c-53.8 0-112.1 23.4-155.6 82.8-52.1 71.2-48.4 163.9-27.2 245.6-32.8 16.9-57.9 46.7-68.4 82.7-5.7-5.8-11.2-12.2-16.6-19.3-64-85-68-164-176-186-5.3-1.1-10.6-1.6-15.7-1.6-100.2 0-170.8 195.1-25.3 301.6 41.5 30.4 90.4 41.8 140.2 41.8 38.7 0 78-6.9 114.7-17.1 16 21.5 38.2 38.2 64 47.2-7 7.3-14.9 14.5-23.9 21.3-85 64-164 68-186 176-13.5 66 59.8 123.8 144.4 123.8 53.8 0 112.1-23.4 155.6-82.8 53.1-72.6 48.2-167.7 25.9-250.4 22.2-13.5 40.1-33.2 51.6-56.7 8.6 7.7 16.9 16.7 24.7 27.1 64 85 68 164 176 186 5.3 1.1 10.6 1.6 15.7 1.6 100.1 0 170.7-195.1 25.3-301.6-41.5-30.4-90.4-41.8-140.2-41.8-33.6 0-67.6 5.2-99.9 13.2-14.1-31.3-39.8-56.2-71.5-69.5 7.6-8.3 16.4-16.4 26.6-24.1 85-64 164-68 186-176 13.4-66-59.8-123.8-144.4-123.8z",
                          fill: "#999",
                          "p-id": "9425",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "svg",
                    {
                      class: { "active-speed": _vm.config.hireWindSpeed === 2 },
                      attrs: {
                        t: "1679650064790",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "9716",
                        width: "24",
                        height: "24",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M603.7 89c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-20.4 15.3-37.6 33.1-51.3 52.8l-8.8 12.7c-11.2-40-16.4-77-15.5-110.2 1.2-40.8 12-75.4 32-102.8 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9.1 38.6-13.8 59.4-13.8M204.2 206.7c5.1 0 9.8 1.2 14.2 3.7 28.6 16.2 39.3 32.4 45.5 44.6 9.3 18.7 14 42.5 19.4 70.1 5.2 26.4 11.1 56.4 22.4 89.3 6.5 18.9 15 36.5 25.4 52.4l16.2 24.9c-41.6-1.8-78.4-8.5-109.5-19.9-37.5-13.7-66.4-34.5-86-61.5-18.4-25.5-28.5-52.4-30-80-1.4-23.7 3.7-47.5 14.6-68.8 8.7-17 21-31.9 34.6-41.8 11.4-8.4 23.2-13 33.2-13m567.5 186.4c17 0 33.6 2.6 49.1 7.7 19.3 6.3 36.3 15.3 50.6 26.7 12.7 10.1 23.3 22.1 31.6 35.8 14.7 24.4 21.5 54.1 18.7 81.7-1.8 17.3-7.2 32.6-15.3 43.1-9.3 12.2-18.8 13.2-21.9 13.6-6.2 0.7-12.2 1.1-17.8 1.1-19.3 0-34.9-4.1-50.6-13.4-16.6-9.8-32.8-24.9-51.6-42.3-19.7-18.3-42.1-39.1-70.6-59.1-16.7-11.7-34.4-21.1-52.5-27.9L614.6 450c25.6-16.9 50.8-30.3 75.1-39.7 28.9-11.5 56.5-17.2 82-17.2m-293.4 27.6l31.1 7.9c13.8 3.5 26.7 10.6 37.2 20.4l26 24.2 1.3 35.4c0.1 1.3 0.1 2.4 0.1 3.4 0 13.8-3.1 26.9-9.4 39.1l-17.3 33.8-36.4 10c-7.4 2-15.1 3.1-22.9 3.1-3.9 0-7.8-0.3-11.7-0.8l-33.5-4.5-21.5-26.4c-8.4-10.2-14.3-22.4-17.2-35.2l-7.9-34.8 18.9-30c8.4-13.4 20.4-24.2 34.5-31.2l28.7-14.4m98.5 191.2l1.1 0.8c33.5 26.9 59.7 55.1 77.9 83.6 20.3 31.6 30.5 63.8 30.3 95.7-0.2 55.3-23.9 89-43.7 107.6-23.7 22.2-55.2 35.4-84.3 35.4-11.7 0-22-2.2-29.9-6.4-6.3-3.4-10.7-7.9-13.5-13.9-13.6-29.9-12.8-49.3-10.5-62.8 3.4-20.6 13.6-42.6 25.5-68.1 11.3-24.4 24.2-52.1 34.4-85.4 5.2-17.1 8.6-34.3 9.9-51.3l2.8-35.2M419.3 639c-14.6 39.2-32.4 72.4-52.9 98.6-24.7 31.6-53.5 52.9-85.4 63.1-17.2 5.5-34.1 8.3-50.5 8.3-36.2 0-62.9-13.7-78.9-25.2-20.4-14.6-36.1-34.4-44.4-55.6-4.8-12.3-6.6-24-5.2-33.8 1.1-7.8 4.1-14 9.3-18.7 27.9-25.5 50.5-30.8 76-30.8 15.9 0 33.2 2.1 53.2 4.5 24.7 3 52.7 6.4 84.3 6.4 2.5 0 5 0 7.5-0.1 22.6-0.4 44.3-3.7 64.7-10l22.3-6.7M603.7 39c-53.8 0-112.1 23.4-155.6 82.8-57 77.9-47.2 181.7-20.7 268.4-22.4 11.2-41.2 28.3-54.5 49.3-7.8-11.9-14.6-25.6-20-41.4-34.6-100.6-14-177-109.9-231.3-12.3-7-25.5-10.2-38.8-10.2-90.5 0-189.6 148.8-92.9 282.8 55.5 76.9 154.7 100.2 244.1 102.5 4.7 20.8 14.2 39.8 27.2 55.8-15.2 4.6-32.1 7.5-50.9 7.8-2.2 0-4.4 0.1-6.6 0.1-53.6 0-97-10.9-137.5-10.9-37.1 0-71.8 9.1-109.8 43.9C6.8 703.7 88.6 859 230.6 859c20.7 0 42.7-3.3 65.7-10.7 90.7-29.1 143.5-116.9 173.3-201.5 6 0.8 12.1 1.2 18.4 1.2 12.5 0 24.7-1.7 36.2-4.9-1 12.8-3.5 26.4-7.8 40.5-31.1 101.7-92.7 151.4-47 251.7 15.2 33.3 49.6 49.6 88.8 49.6 79 0 177.5-66.1 178-192.8 0.3-90.3-60-164.5-126.9-218.4 9.5-18.6 14.8-39.6 14.8-61.8 0-1.8 0-3.5-0.1-5.3 13.6 5.1 27.4 12.3 41.3 22 80.6 56.5 110.8 123.9 201.4 123.9 7.4 0 15.2-0.4 23.4-1.4 109.5-12.5 126.4-238.7-53.7-298-21.4-7.1-43.1-10.2-64.7-10.2-68.2 0-135.3 31.4-191.1 69.3-16.4-15.2-36.5-26.5-58.9-32.2 10.1-14.5 23.3-28.5 40.3-41.4 85-64 164-68 186-176C761.6 96.8 688.3 39 603.7 39z",
                          fill: "#999",
                          "p-id": "9717",
                        },
                      }),
                    ]
                  ),
                  _c("p", [_vm._v("30℃")]),
                ]),
              ]),
              _c("p", { staticClass: "pattern" }, [
                _vm._v(
                  _vm._s(_vm.currentSeason === 1 ? "夏季模式" : "冬季模式")
                ),
              ]),
              _vm.updating
                ? _c(
                    "el-button",
                    {
                      staticClass: "res",
                      attrs: { type: "primary", size: "large" },
                      on: {
                        click: function ($event) {
                          _vm.showProgress = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-loading" }),
                      _c("span", [_vm._v("季节设置")]),
                    ]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "res",
                      attrs: {
                        type: "primary",
                        size: "large",
                        icon: "el-icon-setting",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showConfig = true
                        },
                      },
                    },
                    [_vm._v("季节设置")]
                  ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "wrapper old" },
            [
              _c(
                "div",
                { staticClass: "season-banner" },
                [
                  _vm.currentSeason === 1
                    ? [
                        _c("el-image", {
                          attrs: {
                            fit: "fill",
                            src: "https://resource-1259700724.cos.ap-guangzhou.myqcloud.com/image/20230407/ceb52bd608e447f8c86083653d022992.png",
                            alt: "",
                          },
                        }),
                        _vm._m(0),
                      ]
                    : [
                        _c("el-image", {
                          attrs: {
                            fit: "fill",
                            src: "https://resource-1259700724.cos.ap-guangzhou.myqcloud.com/image/20230407/bd64e2016205e4eb210509c506f9b66b.png",
                            alt: "",
                          },
                        }),
                        _vm._m(1),
                      ],
                ],
                2
              ),
              _vm.updating
                ? _c(
                    "el-button",
                    {
                      staticClass: "res",
                      attrs: { type: "primary", size: "large" },
                      on: {
                        click: function ($event) {
                          _vm.showProgress = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-loading" }),
                      _c("span", [_vm._v("切换季节")]),
                    ]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "res",
                      attrs: {
                        type: "primary",
                        size: "large",
                        icon: "el-icon-refresh",
                      },
                      on: { click: _vm.changeSeason },
                    },
                    [_vm._v("切换季节")]
                  ),
            ],
            1
          ),
      _c("seasonal-pattern-config", {
        attrs: {
          visible: _vm.showConfig,
          "edit-id": _vm.editId,
          seasonal: _vm.currentSeason,
          "summer-config": _vm.summerConfig,
          "winter-config": _vm.winterConfig,
          "no-card-take-electricity-config": _vm.noCardTakeElectricityConfig,
          "only-close-valve": _vm.onlyCloseValve,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showConfig = $event
          },
          change: _vm.patternChange,
        },
      }),
      _c(
        "my-dialog-small",
        {
          attrs: {
            visible: _vm.showConfirm,
            title: "更新季节设置授权",
            loading: _vm.loading,
            "before-close": _vm.confirmClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showConfirm = $event
            },
          },
        },
        [
          _c("p", { staticClass: "font-l" }, [
            _vm._v("确定要更新到所有房间主机吗？"),
          ]),
          _c("p", { staticClass: "mv-2x" }, [
            _vm._v("如需更新，请输入授权码点击确定按钮开始更新。"),
          ]),
          _c("div", { staticClass: "password flex-start" }, [
            _c("span", { staticClass: "mr-1x" }, [_vm._v("请输入授权码")]),
            _c(
              "div",
              { staticClass: "relative", attrs: { autocomplete: "off" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.unnecessary,
                      expression: "unnecessary",
                    },
                  ],
                  staticClass: "unnecessary",
                  attrs: { placeholder: "请输入" },
                  domProps: { value: _vm.unnecessary },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.unnecessary = $event.target.value
                    },
                  },
                }),
                _c("el-input", {
                  attrs: {
                    size: "large",
                    placeholder: "请输入登录密码",
                    "show-password": "",
                    clearable: "",
                    autocomplete: "new-password",
                  },
                  model: {
                    value: _vm.password,
                    callback: function ($$v) {
                      _vm.password = $$v
                    },
                    expression: "password",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "my-dialog-small",
        {
          attrs: { visible: _vm.showProgress, title: "季节设置更新中" },
          on: {
            "update:visible": function ($event) {
              _vm.showProgress = $event
            },
          },
        },
        [
          _c("p", { staticClass: "mb-1x" }, [
            _c("span", { staticClass: "text-v" }, [_vm._v("已完成房间：")]),
            _c("span", { staticClass: "font-xl text-v" }, [
              _vm._v(_vm._s(_vm.done) + "/" + _vm._s(_vm.total)),
            ]),
          ]),
          _c("el-progress", {
            attrs: {
              "text-inside": true,
              "stroke-width": 24,
              percentage: _vm.percentage,
            },
          }),
          _c("template", { slot: "footer" }, [
            _vm.updated
              ? _c("div", { staticClass: "font-l" }, [
                  _c("p", { staticClass: "text-c p-2x green" }, [
                    _c("i", { staticClass: "el-icon-circle-check mr-x" }),
                    _c("span", [
                      _vm._v("更新完成：成功" + _vm._s(_vm.success) + "间；"),
                    ]),
                    _c(
                      "u",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.showFail = true
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v("失败" + _vm._s(_vm.fail) + "间！"),
                        ]),
                        _c("span", { staticClass: "el-icon-zoom-in ml-x" }),
                      ]
                    ),
                  ]),
                ])
              : _c("p", { staticClass: "text-c p-2x" }, [
                  _c("i", { staticClass: "el-icon-loading mr-x" }),
                  _c("span", [_vm._v("正在更新中，请耐心等待...")]),
                ]),
          ]),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "更新失败房间列表",
            visible: _vm.showFail,
            width: "768px",
          },
          on: { close: _vm.closeFail },
        },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "roomNumber",
                  label: "房间号",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "mac", label: "MAC", "min-width": "150" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "errMsg",
                  label: "失败原因",
                  "min-width": "400",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "footer",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.againIng },
                  on: { click: _vm.again },
                },
                [_vm._v("重试")]
              ),
              _c("el-button", { on: { click: _vm.closeFail } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "desc" }, [
      _c("h3", [_vm._v("夏季模式")]),
      _c("p", { staticClass: "mt-1x" }, [_vm._v("酒店房间设置为夏季模式")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "desc winter" }, [
      _c("h3", [_vm._v("冬季模式")]),
      _c("p", { staticClass: "mt-1x" }, [_vm._v("酒店房间设置为冬季模式")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }